export const UPDATE_DYNAMIC_CONTENT_TIMEOUT = 50;
export const UNIQUE_ATTRIBUTES = ['id', 'name', 'for'];
